import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginContainerModelUpdate} from '../../../../../models/aggregates/id';
import {BasicApiResponseModel} from '../shared/api-response.model';
import {ApiVisa} from '../shared/api-visa.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdentityUserProfileService extends BaseApiTemplateService<AppLoginContainerModelUpdate> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/userprofile';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/userprofile';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/userprofile';
    this.httpClient = http;
  }

  public getByTenantGuidOrCode(
    GuidOrCode: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<AppLoginContainerModelUpdate>> {
    return this.httpClient.get<BasicApiResponseModel<AppLoginContainerModelUpdate>>(
      this.apiUrl + '/by-tenant/' + GuidOrCode,
      this.getHttpHeader(visa)
    );
  }
}
